import { render, staticRenderFns } from "./integralEden.vue?vue&type=template&id=04f156d8&scoped=true"
import script from "./integralEden.vue?vue&type=script&lang=js"
export * from "./integralEden.vue?vue&type=script&lang=js"
import style0 from "./integralEden.vue?vue&type=style&index=0&id=04f156d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f156d8",
  null
  
)

export default component.exports